export const PROMPT_NAME = 'ComponentConfigurationWebsiteCopyPrompt';
